export default __webpack_public_path__ + "static/media/play.eb10bdc6.png";